export default __webpack_public_path__ + "d3e9b26abe747360c34c34758a2da931.svg";